import {Document, Page, StyleSheet, Text, View} from '@react-pdf/renderer';
import * as React from 'react';
import {paginate} from '../../../util/paginate';

export const getRankingReportPdfExport = (reportName: string, exportData: any[], rollupRowsIdx: number[], industryAvgRowsIdx: number[]) => {
  // split columns
  const dataColumns = exportData[0];
  const numberOfSplits = parseInt((dataColumns.length / 7).toString(), 10) + (dataColumns.length % 7 ? 1 : 0);
  const pages = []
  for (let currentPage = 1; currentPage <= numberOfSplits; currentPage++) {
    const columnTitles = paginate(exportData[0], currentPage, 7);
    const columnValues = paginate(exportData[1], currentPage, 7);
    const rows = [];
    for (let j = 2; j < exportData.length; j++) {
      const row = paginate(exportData[j], currentPage, 7);
      rows.push(row);
    }
    pages.push([columnTitles, columnValues, ...rows])
  }
  const styles = StyleSheet.create({
    page: {
      flexDirection: 'column',
      backgroundColor: 'white',
      fontSize: 12,
      padding: '12mm'
    },
    table: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap'
    },
    reportTitle: {
      fontWeight: 'bold',
      fontSize: 16,
      textAlign: 'center',
      marginBottom: '5mm'
    },
    columnTitle: {
      fontWeight: 'bold'
    },
    tableCell: {
      maxWidth: '40mm',
      width: '40mm',
      padding: '2.5mm',
      textAlign: 'center',
      borderBottomStyle: 'solid',
      borderBottom: 1,
      borderBottomColor: '#00000033'
    },
    tableCellRollup: {
      maxWidth: '40mm',
      width: '40mm',
      padding: '2.5mm',
      textAlign: 'center',
      borderBottomStyle: 'solid',
      borderBottom: 1,
      borderBottomColor: '#00000033',
      backgroundColor: '#bcbcbc',
    },
    tableCellIndustryAvg: {
      maxWidth: '40mm',
      width: '40mm',
      padding: '2.5mm',
      textAlign: 'center',
      borderBottomStyle: 'solid',
      borderBottom: 1,
      borderBottomColor: '#00000033',
      backgroundColor: '#FFD700',
    },
    tableCellColumnHeader: {
      fontWeight: 'bold',
      fontSize: 14,
      maxWidth: '40mm',
      width: '40mm',
      padding: '2.5mm',
      textAlign: 'center',
      borderBottomStyle: 'solid',
      borderBottom: 2,
      borderBottomColor: '#00000033'
    },
    tableCellColumnHeaderBorderless: {
      fontWeight: 'bold',
      fontSize: 14,
      maxWidth: '40mm',
      width: '40mm',
      padding: '2.5mm',
      textAlign: 'center',
      marginBottom: '5mm'
    },
    bgColorTableCell: {
      maxWidth: '40mm',
      width: '40mm',
      padding: '2.5mm',
      backgroundColor: 'lightgray',
      textAlign: 'center',
      borderBottomStyle: 'solid',
      borderBottom: 1,
      borderBottomColor: '#00000033'
    },
    textCenter: {
      textAlign: 'center'
    }
  })
  const exportedPDF = () => (
    <Document>
      {pages.map((page, idx) => {
        return (
          <Page size="A4" style={styles.page} orientation="landscape" key={idx}>
            <View style={styles.reportTitle}>
              <Text>
                {reportName}
              </Text>
            </View>
            <View style={styles.table}>
              {page[0].map((column, idy) => {
                return(
                  <View style={styles.tableCellColumnHeaderBorderless} key={idy}>
                    <Text style={styles.columnTitle}>{column}</Text>
                  </View>
                );
              })}
            </View>
            <View style={styles.table}>
              {page[1].map((column, idy) => {
                return(
                  <View style={styles.tableCellColumnHeader} key={idy}>
                    <Text style={styles.columnTitle}>{column}</Text>
                  </View>
                );
              })}
            </View>
            {page.slice(2).map((row, rowIndex) => {
              return (
                <View style={styles.table} key={rowIndex}>
                  {row.map((column, idz) => {
                    const idv = idz - 2;
                    const value = column.length > 0 ? column : '-';
                    if (industryAvgRowsIdx.includes(Number(rowIndex))) {
                      return(
                        <View style={styles.tableCellIndustryAvg} key={idz}>
                          <Text style={styles.columnTitle}>{value}</Text>
                        </View>
                      );
                    }
                    if (rollupRowsIdx.includes(Number(rowIndex))) {
                      return(
                        <View style={styles.tableCellRollup} key={idz}>
                          <Text style={styles.columnTitle}>{value}</Text>
                        </View>
                      );

                    } else {
                      if (idv >= 0 && idv % 2 === 0) {
                        return(
                          <View style={styles.bgColorTableCell} key={idz}>
                            <Text style={styles.columnTitle}>{value}</Text>
                          </View>
                        );
                      } else {
                        return(
                          <View style={styles.tableCell} key={idz}>
                            <Text style={styles.columnTitle}>{value}</Text>
                          </View>
                        );
                      }

                    }
                  })}
                </View>
              )
            })}
          </Page>
        )
      })}
    </Document>
  );

  return exportedPDF();
}
